export * from './LocationResultCardContent';
